export default __webpack_public_path__ + "static/media/nft4.ff2eb540.png";